import './App.css';
import {
    Box,
    Drawer,
    Toolbar,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Avatar,
    IconButton
} from '@mui/material';
import {
    Apps,
    Hub as Subnet,
    Dns as Server,
    Add,
    ShoppingBagOutlined,
    Close,
    ArrowBack,
    InfoOutlined,
    ApiOutlined, InstallDesktop, InstallMobile,
} from '@mui/icons-material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as React from "react";
import {isMobile, kbIdToSubdomainUrl, parseKBSubdomain} from "./utils.js";
import {useState} from "react";
import Divider from "@mui/material/Divider";
import {getKBImage} from "../KB/KBImage";
import {deleteRecentApp, getBaseUrl, getRecentApps, updateRecentApps} from "../utils";
import LocalLoader from "../Loaders/LocalLoader";
import {ChatsList} from "./ChatsHistory";
import {KBName, KBNamePlural} from "../names";
import SchoolIcon from "@mui/icons-material/School";


// Left Menu
export function LeftMenu({ open, drawerWidth, handleDrawerClose, tabStyle, network, pathSegments, kbSubdomain,
                           kbChats, setKBChats, navigateToChat, isStreaming, unreadMessages, ChatData, setChatData}) {
    const navigate = useNavigate();
    const location = useLocation();
    const firstPathSegment = location.pathname.split('/')[1] || '';
    const isApiSubMenuOpen = location.pathname.startsWith('/api/');
    const [recentApps, setRecentApps] = useState(getRecentApps());
    const [loading, setLoading] = useState(false);

    const tabStyleChat = {
        height: '35px',
        minWidth: '100%',
        justifyContent: 'flex-start',
        marginLeft: '0px',
    };

    const baseStyle = {
        '.MuiListItemIcon-root': {
            minWidth: '40px',
            marginRight: '8px'
        },
        '.MuiListItemText-primary': {
            fontWeight: 'normal'
        },
        margin: '8px 15px',
        padding: '5px 10px',
        borderRadius: '5px',
    }

    const handleNavigateWrapper = (event, path) => {
        event.preventDefault();
        let myPath = path;
        if (myPath === '/' || !myPath) myPath = '/dashboard';
        const baseUrl = getBaseUrl();
        if (event?.ctrlKey || event?.metaKey || path === '/tutorials') {
            // Open in a new tab if Ctrl or Meta (Cmd on Mac) is pressed
            window.open(baseUrl + myPath, '_blank');
        } else {
            if (kbSubdomain) {
                window.location.href = baseUrl + myPath;
            } else {
                handleNavigate(myPath);
            }

        }
    }

    const handleNavigate = (path, event) => {
        if (event?.ctrlKey || event?.metaKey) {
            window.open(path, '_blank');
        } else {
            const { kbIdAsSubdomain, mainDomain, protocol } = parseKBSubdomain() || {};
            if (kbIdAsSubdomain) {
                window.location.href = `${protocol}//${mainDomain}` + path;
            } else {
                navigate(path, { replace: true });
            }
            if (isMobile) {
                handleDrawerClose();
            }
        }
    };

    const listItemTextStyle = {
        '.MuiListItemText-primary': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '0.875rem'
        },
    };

    const handleDeleteRecentApp = (e, kbId) => {
        e.stopPropagation();
        e.preventDefault()
        deleteRecentApp(kbId);
        setRecentApps(prev => prev.filter(app => app.kbId !== kbId));
    };

    return (
        <Drawer
            variant="persistent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
            open={open}
        >
            <Toolbar />
            <LocalLoader open={loading} blocking={true} />
            <Box sx={{ overflow: 'auto', position: 'relative', height: '100%' }}>
                <List>
                    {!kbSubdomain && <>
                        <ListItemButton
                            disableRipple
                            selected={!kbSubdomain && firstPathSegment === '/dashboard'}
                            onClick={(e) => handleNavigateWrapper(e, '/dashboard')}
                            sx={tabStyle}
                        >
                            <ListItemIcon>
                                <Apps />
                            </ListItemIcon>
                            <ListItemText primary={"My " + KBNamePlural} />
                        </ListItemButton>

                        <ListItemButton
                            disableRipple
                            selected={!kbSubdomain && location.pathname.includes('/create')}
                            onClick={(e) => handleNavigateWrapper(e, '/create')}
                            sx={tabStyle}
                        >
                            <ListItemIcon>
                                <Add />
                            </ListItemIcon>
                            <ListItemText primary={`Create ${KBName}`} />
                        </ListItemButton>

                        <ListItemButton
                            disableRipple
                            selected={!kbSubdomain && location.pathname.includes('/app-center')}
                            onClick={(e) => handleNavigateWrapper(e, '/app-center')}
                            sx={tabStyle}
                        >
                            <ListItemIcon><InstallMobile /></ListItemIcon>
                            <ListItemText primary="App Center" />
                        </ListItemButton>

                        {/* API Submenu */}
                        <ListItemButton
                            disableRipple
                            onClick={(e) => handleNavigateWrapper(e, '/api/cli')}
                            sx={tabStyle}
                        >
                            <ListItemIcon><ApiOutlined /></ListItemIcon>
                            <ListItemText primary="API" />
                        </ListItemButton>

                        <Collapse in={isApiSubMenuOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {/*<ListItemButton*/}
                                {/*    disableRipple*/}
                                {/*    selected={!kbSubdomain && location.pathname.includes('/api/introduction')}*/}
                                {/*    onClick={(e) => handleNavigateWrapper(e, '/api/introduction')}*/}
                                {/*    sx={{ ...tabStyle, pl: 4 }}*/}
                                {/*>*/}
                                {/*    <ListItemIcon>*/}
                                {/*        /!*<Insights />*!/*/}
                                {/*    </ListItemIcon>*/}
                                {/*    <ListItemText primary="Introduction" />*/}
                                {/*</ListItemButton>*/}

                                <ListItemButton
                                    disableRipple
                                    selected={!kbSubdomain && location.pathname.includes('/api/cli')}
                                    onClick={(e) => handleNavigateWrapper(e, '/api/cli')}
                                    sx={{ ...tabStyle, pl: 4 }}
                                >
                                    <ListItemIcon>
                                        {/*<TerminalOutlined />*/}
                                    </ListItemIcon>
                                    <ListItemText primary="Install CLI" />
                                </ListItemButton>

                                <ListItemButton
                                    disableRipple
                                    selected={!kbSubdomain && location.pathname.includes('/api/services')}
                                    onClick={(e) => handleNavigateWrapper(e, '/api/services')}
                                    sx={{ ...tabStyle, pl: 4 }}
                                >
                                    <ListItemIcon>
                                        {/*<ApiOutlined />*/}
                                    </ListItemIcon>
                                    <ListItemText primary="Services" />
                                </ListItemButton>
                            </List>
                        </Collapse>
                        <ListItemButton
                            disableRipple
                            onClick={(e) => handleNavigateWrapper(e, '/tutorials')}
                            sx={tabStyle}
                        >
                            <ListItemIcon><SchoolIcon /></ListItemIcon>
                            <ListItemText primary="Tutorials" />
                        </ListItemButton>


                    </>}


                    {kbSubdomain
                        ? <>
                            <ListItemButton
                                disableRipple
                                selected={false}
                                onClick={(e) => handleNavigateWrapper(e, '/dashboard')}
                                sx={tabStyle}
                            >
                                <ListItemIcon>
                                    <ArrowBack />
                                </ListItemIcon>
                                <ListItemText primary={"Back to " + KBNamePlural} />
                            </ListItemButton>
                            {/*<Divider textAlign="center" style={{ margin: '24px 16px 24px 16px' }}>Chat List</Divider>*/}
                            <ChatsList {...{kbChats, setKBChats, isStreaming, navigateToChat, unreadMessages, ChatData, setChatData}} />
                          </>
                        : !!recentApps?.length && <>
                            <Divider  textAlign="center" style={{ margin: '24px 16px 24px 16px' }}>Recent Apps</Divider>
                        <List sx={{ paddingRight: '28px', marginTop: '-6px' }}>
                            {recentApps.map(({ kbId, title }) => (
                                <li key={`${kbId}-recent`} style={{ position: 'relative', marginLeft: '-9px' }}>
                                    <ListItemButton
                                        disableRipple
                                        onClick={(e) => {
                                            updateRecentApps(kbId, title)
                                            const url = kbIdToSubdomainUrl(kbId);
                                            if (e.ctrlKey || e.metaKey) {
                                                window.open(url, '_blank');
                                            } else {
                                                window.location.href = url;
                                            }
                                        }}
                                        sx={{ ...tabStyleChat, ...baseStyle, '&:hover': { backgroundColor: 'transparent' } }}
                                    >
                                        <ListItemIcon>
                                            <Avatar alt={title}
                                                    src={getKBImage(kbId)}
                                                    style={{width: 24, height: 24, borderRadius: '50%'}} />
                                        </ListItemIcon>
                                        <ListItemText primary={title} sx={listItemTextStyle} />
                                        <IconButton
                                            onClick={(e) => handleDeleteRecentApp(e, kbId)}
                                            size="small"
                                            sx={{
                                                position: 'absolute',
                                                right: 5,
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                opacity: 0,
                                                '&:hover': {opacity: 1},
                                                '.MuiListItemButton-root:hover &': {opacity: 1},
                                            }}
                                        >
                                            <Close fontSize="small" style={{fontSize: 14}}/>
                                        </IconButton>
                                    </ListItemButton>
                                </li>
                            ))}
                        </List>
                        </>}

                    {network?.map((net, index) => (
                        <React.Fragment key={index}>
                            <ListItemButton
                                disableRipple
                                // selected={pathSegments[2] === encodeURIComponent(net.subnet)}
                                component={Link}
                                sx={{...tabStyle, pl: 4}}>
                                <ListItemIcon>
                                    <Subnet/>
                                </ListItemIcon>
                                <ListItemText primary={net.subnet}/>
                            </ListItemButton>

                            {net.servers.map((server, index) => (
                                <ListItemButton
                                    disableRipple
                                    selected={pathSegments[2] === net.subnet && pathSegments[3] === encodeURIComponent(server.url)}
                                    key={index}
                                    to={`/network/${encodeURIComponent(net.subnet)}/${encodeURIComponent(server.url)}`}
                                    component={Link} sx={{...tabStyle, pl: 6}}>
                                    <ListItemIcon>
                                        <Server/>
                                    </ListItemIcon>
                                    <ListItemText primary={server.url}/>
                                </ListItemButton>
                            ))}
                        </React.Fragment>
                    ))}
                </List>
            </Box>
        </Drawer>
    );
}